<template functional>
  <div>
    Forderung <span
      v-if="props.row.item_real === 'N'"
      class="font-bold"
    >(Vorbuchung)</span>
    <br>
    <span class="tracking-wider text-gray-700">
      {{ props.row.item_type == 'bonus' ? 'Bonus' : 'Prämie' }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'MiaCarProvisionAccountingTypeDatatableColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
